import { CompanyAccountModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../../shared';
import { Account } from './account';
import { emptyCompanyAccount } from '../../../../company/company-account.entity';
import { clone } from '@jack-henry/frontend-utils/functions';

export class CompanyAccount extends DomainEntity<CompanyAccountModelDto> {
    public createDefault(): this {
        return new CompanyAccount(clone(emptyCompanyAccount)) as this;
    }

    public get id() {
        return this.dto.id;
    }

    public get updatedDate() {
        return this.dto.updatedDate;
    }

    public get account() {
        if (!this.dto.account) {
            return undefined;
        }
        return new Account(this.dto.account);
    }

    public get name() {
        return this.dto.name;
    }

    public get number() {
        return this.dto.number;
    }

    public get status() {
        return this.dto.status;
    }

    public get currentBalance() {
        return this.dto.currentBalance;
    }

    public get collectedBalance() {
        return this.dto.collectedBalance;
    }

    public get availableBalance() {
        return this.dto.availableBalance;
    }

    public get type() {
        return this.dto.type;
    }

    public get perTransactionLimit() {
        return this.dto.perTransactionLimit;
    }

    public get dailyLimit() {
        return this.dto.dailyLimit;
    }

    public get cifNumber() {
        return this.dto.cifNumber;
    }

    public get isDeleted() {
        return this.dto.isDeleted;
    }

    public get showAccountNickName() {
        return this.dto.showAccountNickName;
    }

    public get accountDisplayLabel() {
        return this.dto.accountDisplayLabel;
    }

    public get transferAmount() {
        return this.dto.transferAmount;
    }

    public get transferMemo() {
        return this.dto.transferMemo;
    }

    public get loanPaymentAmountDue() {
        return this.dto.loanPaymentAmountDue;
    }

    public get loanPaymentDueDate() {
        return this.dto.loanPaymentDueDate;
    }

    public get allowLoanPaymentPastDue() {
        return this.dto.allowLoanPaymentPastDue;
    }

    public get accountUniqueId() {
        return this.dto.accountUniqueId;
    }
}
